import type { PlaybookSectionNode } from "@repo/app-types/entities/playbook";
import type { RecordingGradingAssessment } from "@repo/app-types/entities/recording";
import { computeAggregatedAdherenceScore } from "@repo/app-types/helpers/gradingAssessmentHelpers";
import { Size } from "@repo/ui/helpers/helpers";
import { type FC, useMemo } from "react";
import { GradingPassRatePill } from "./gradingPassRatePill.js";

export interface GradingAssessmentSectionSummaryProps {
  section: PlaybookSectionNode;
  assessment: RecordingGradingAssessment;
}

export const GradingAssessmentSectionSummary: FC<
  GradingAssessmentSectionSummaryProps
> = (props) => {
  const passRate = useMemo(() => {
    return (
      computeAggregatedAdherenceScore(props.assessment, props.section) ??
      undefined
    );
  }, [props.section, props.assessment]);

  return <GradingPassRatePill size={Size.SMALL} passRate={passRate} />;
};
